var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Transform } from 'class-transformer';
class QueryStringModel {
    query;
    fields;
    type;
    default_operator;
    max_determinized_states;
    enable_position_increments;
    fuzziness;
    fuzzy_prefix_length;
    fuzzy_max_expansions;
    phrase_slop;
    escape;
    auto_generate_synonyms_phrase_query;
    fuzzy_transpositions;
    boost;
}
class FilterBoolModel {
    query_string;
    term;
    terms;
    bool;
    match_phrase;
    exists;
    lookup;
}
class BoolModel {
    must;
    should;
    filter;
    must_not;
}
class QueryFiltersModel {
    bool;
}
class QueryAggregationModel {
    aggregationType;
    fieldToAggregateOn;
    valueToAggregateOn;
}
class QueryModel {
    query;
    filters;
    groupBy;
    aggregation;
    shouldQueryOnAllAccounts;
    accountIdsToQueryOn;
}
export class AlertEventDetailsModel {
    id;
    fromDate;
    toDate;
    query;
}
__decorate([
    Expose({ name: 'alertEventId' }),
    __metadata("design:type", String)
], AlertEventDetailsModel.prototype, "id", void 0);
__decorate([
    Transform((value) => parseInt(value.toString(), 10) * 1000, { toClassOnly: true }),
    __metadata("design:type", Number)
], AlertEventDetailsModel.prototype, "fromDate", void 0);
__decorate([
    Transform((value) => parseInt(value.toString(), 10) * 1000, { toClassOnly: true }),
    __metadata("design:type", Number)
], AlertEventDetailsModel.prototype, "toDate", void 0);
//# sourceMappingURL=alert-event-details.js.map